<template>
  <div class="mt-1 mb-4 d-flex align-center audio-recorder">
    <p>Thu âm</p>
    <v-btn
      @click="startRecording"
      v-if="!isRecording"
      class="mx-2 audio-record-control"
      fab
      dark
      small
      color="pink"
      min-width="40"
      width="40"
    >
      <v-icon dark> mdi-microphone </v-icon>
    </v-btn>
    <v-btn
      @click="stopRecording"
      v-else
      class="mx-2 audio-record-control"
      fab
      dark
      small
      color="pink"
    >
      <v-icon dark> mdi-stop-circle </v-icon>
    </v-btn>

    <div v-if="isRecording" class="music-waves-2">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script>
// import { createFFmpeg } from "@ffmpeg/ffmpeg";
export default {
  data() {
    return {
      isRecording: false,
      mediaRecorder: null,
      audioChunks: [],
      audioUrl: null,
      audioFile: null,
      stream: null, // Save the stream to stop microphone access later
      // ffmpeg: createFFmpeg({ log: true }),
    };
  },
  methods: {
    // Detect MIME type supported by current browser.
    // Safari iOS only supports audio/mp4; Chrome/Firefox support audio/webm.
    getSupportedMimeType() {
      const candidates = [
        "audio/mp4", // Safari iOS / Safari macOS
        "audio/webm;codecs=opus", // Chrome, Edge, Firefox
        "audio/webm", // Chrome, Edge, Firefox (fallback)
        "audio/ogg;codecs=opus", // Firefox
      ];
      return candidates.find((t) => MediaRecorder.isTypeSupported(t)) || "";
    },

    getExtFromMimeType(mimeType) {
      if (mimeType.includes("mp4")) return "mp4";
      if (mimeType.includes("ogg")) return "ogg";
      return "webm";
    },

    async startRecording() {
      try {
        // Release any leftover stream from a previous recording before starting
        this.releaseStream();

        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
        });
        this.stream = stream; // save so we can release the mic after stopping

        // Detect correct MIME type so the blob is labeled accurately.
        // Hardcoding "audio/wav" while MediaRecorder produces mp4/webm
        // causes Safari iOS to fail decoding on playback.
        const mimeType = this.getSupportedMimeType();
        const options = mimeType ? { mimeType } : {};
        this.mediaRecorder = new MediaRecorder(stream, options);
        this.audioChunks = []; // reset chunks for new recording

        this.mediaRecorder.ondataavailable = (event) => {
          this.audioChunks.push(event.data);
        };

        this.mediaRecorder.onstop = () => {
          // Use the actual mimeType the recorder used, not a hardcoded label.
          const actualMimeType =
            this.mediaRecorder.mimeType || mimeType || "audio/webm";
          const ext = this.getExtFromMimeType(actualMimeType);
          const audioBlob = new Blob(this.audioChunks, {
            type: actualMimeType,
          });
          this.audioUrl = URL.createObjectURL(audioBlob);
          this.audioChunks = [];
          this.audioFile = new File([audioBlob], `recording.${ext}`, {
            type: actualMimeType,
          });
          // Release the microphone now that all data has been collected
          this.releaseStream();
        };

        this.mediaRecorder.start();
        this.isRecording = true;
      } catch (error) {
        console.error("Error accessing media devices.", error);
        alert("Error accessing media devices.");
      }
    },
    async stopRecording() {
      if (this.mediaRecorder) {
        this.mediaRecorder.stop();
        this.isRecording = false;
        setTimeout(() => {
          this.$emit("stopRecord", {
            audioUrl: this.audioUrl,
            audioFile: this.audioFile,
          });
        }, 500);
      }
    },
    releaseStream() {
      if (this.stream) {
        this.stream.getTracks().forEach((track) => track.stop());
        this.stream = null;
      }
    },
  },
  beforeDestroy() {
    // Ensure mic is released if user navigates away mid-recording
    this.releaseStream();
  },
};
</script>

<style scoped>
button {
  margin-right: 10px;
}
.audio-recorder {
  gap: 10px;
}
.music-waves-2 {
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.music-waves-2 > span {
  display: block;
  position: relative;
  background: #000;
  height: 100%;
  width: 1rem;
  border-radius: 1rem;
  margin: 0 0.2rem;
  animation: waves-2 1.2s linear infinite;
}

.music-waves-2 > span:nth-child(1) {
  animation-delay: 0s;
  background: #ff8c00;
}

.music-waves-2 > span:nth-child(2) {
  animation-delay: 0.3s;
  background: #ffff00;
}

.music-waves-2 > span:nth-child(3) {
  animation-delay: 0.6s;
  background: #26d53a;
}

.music-waves-2 > span:nth-child(4) {
  animation-delay: 0.9s;
  background: #26e6a3;
}

.music-waves-2 > span:nth-child(5) {
  animation-delay: 0.6s;
  background: #1da8e2;
}

.music-waves-2 > span:nth-child(6) {
  animation-delay: 0.3s;
  background: #5916ba;
}

.music-waves-2 > span:nth-child(7) {
  animation-delay: 0s;
  background: #d418d9;
}

@keyframes waves-2 {
  50% {
    height: 20%;
  }

  100% {
    height: 100%;
  }
}
</style>
